import React, { useState, useEffect, useContext } from 'react'
import { StoreContext } from "../../context/StoreContext"
import Utility from "../../objects/Utility"
import './SheetEdit.scss'

const SheetEdit = ({ changeSheetMenuEditOpened }) => {
    const controller = new AbortController();
    const { state, actions } = useContext(StoreContext)
    const [sheetEditOpen, setSheetEditOpen] = useState(false)
    const [commonInputs, setCommonInputs] = useState([])

    useEffect(() => {

        return () => {
            controller.abort();
        };

    }, []) // eslint-disable-line react-hooks/exhaustive-deps 

    const setupCommonInputs = () => {
        let occupied = state.slots.filter(slot => slot.counterState)
        let _commonInputs = []
        let inputLibrary = []
        occupied.forEach(oc => {
            let entry = {}
            entry.slotNumber = oc.number
            entry.layersData = []
            oc.counterState.package.layers.forEach(layer => {
                let layerInputs = layer.inputs
                let stateLayer = state.layers.find( ly => ly.layerKey === layer.layerKey)
                stateLayer.inputs.forEach(input => {
                        let found = _commonInputs.find( ci => ci.named === input.named  )
                        if( !found ) {
                            inputLibrary.push(input)
                            _commonInputs.push({
                                named: input.named, 
                                locations: [{ slotNumber: oc.number, layerKeys: [layer.layerKey]}]
                            })
                        }
                        else {
                            let location = found.locations.find( loc => loc.slotNumber === oc.number )
                            if( location ) {
                                let layerKeys = location.layerKeys
                                if( !layerKeys.includes(layer.layerKey) ) {
                                    layerKeys.push(layer.layerKey)
                                }
                            }
                            else {
                                found.locations.push({ slotNumber: oc.number, layerKeys: [layer.layerKey] })
                            }
                        }
                })
            })
        })
console.log('and we have _commonInputs:', _commonInputs)
        console.log('and we have inputLibrary:', inputLibrary)
        setCommonInputs(_commonInputs)
    }

    useEffect(() => {
        changeSheetMenuEditOpened(sheetEditOpen)
        if( commonInputs.length === 0 && sheetEditOpen) {
            setupCommonInputs()
        }
    }, [sheetEditOpen]) // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if( sheetEditOpen) {
            setupCommonInputs()
        }
    }, [state.slots])

    useEffect(() => {
       // console.log('useEffect commonInputs:', commonInputs)
    }, [commonInputs]) // eslint-disable-line react-hooks/exhaustive-deps

    return (

        <div className={sheetEditOpen ? 'sheet-edit opened' : 'sheet-edit'}>

            <div className={sheetEditOpen ? 'controls-opener opened' : 'controls-opener closed'}>
                <div className="title">sheet edit {sheetEditOpen ? 'open' : 'closed'}</div>
                <button className={sheetEditOpen ? 'standard-button yellow closed' : 'standard-button yellow'} onClick={() => setSheetEditOpen(false)}>open</button>
                <button className={sheetEditOpen ? 'standard-button red' : 'standard-button red closed'} onClick={() => setSheetEditOpen(false)}>close</button>
            </div>

            <div className={sheetEditOpen ? 'controls' : 'display-none'}>
                <div className="sheet-edit-controls">
                    {/* {occupiedSlots.map((slot, index) => {
                        return (
                            <div key={index} className="slot-edit">
                                <div className="slot-number">slot {slot.slotNumber}</div>
                                <div className="slot-layers">
                                    {slot.layersData.map((layer, index) => {
                                        return (
                                            <div key={index} className="layer-edit">
                                                <div className="layer-name">{layer.layerKey}: {layer.layerName}</div>
                                    
                                                <div className="layer-input-keys">input keys: {layer.layerInputKeys.join(',')}</div>
                                                <div className="required-input-key">required: {layer.requiredInputKey}</div>
                                                <div className="layer-opacity">opacity: {layer.layerOpacity}</div>
                                            </div>
                                        )
                                    })}
                                </div>
                            </div>
                        )
                    })} */}
                </div>

            </div>
        </div>

    );
}
export default SheetEdit
